export default "__VITE_PUBLIC_ASSET__1dce322f__"